const ArrowCircleIcon = ({
  showGradient = false,
}: {
  showGradient?: boolean;
}) => {
  return showGradient ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.02026 -3.49691e-07C10.142 -4.42435e-07 12.1768 0.842854 13.6771 2.34314C15.1774 3.84344 16.0203 5.87827 16.0203 8C16.0203 10.1217 15.1774 12.1566 13.6771 13.6569C12.1768 15.1571 10.142 16 8.02026 16C5.89853 16 3.8637 15.1571 2.36341 13.6569C0.863118 12.1566 0.0202634 10.1217 0.0202633 8C0.0202632 5.87827 0.863118 3.84344 2.36341 2.34315C3.8637 0.842854 5.89853 -2.56947e-07 8.02026 -3.49691e-07ZM4.52026 7.5C4.38765 7.5 4.26048 7.55268 4.16671 7.64645C4.07294 7.74021 4.02026 7.86739 4.02026 8C4.02026 8.13261 4.07294 8.25978 4.16671 8.35355C4.26048 8.44732 4.38765 8.5 4.52026 8.5L10.3133 8.5L8.16626 10.646C8.07238 10.7399 8.01963 10.8672 8.01963 11C8.01963 11.1328 8.07238 11.2601 8.16626 11.354C8.26015 11.4479 8.38749 11.5006 8.52026 11.5006C8.65304 11.5006 8.78038 11.4479 8.87426 11.354L11.8743 8.354C11.9208 8.30755 11.9578 8.25238 11.983 8.19163C12.0082 8.13089 12.0212 8.06577 12.0212 8C12.0212 7.93423 12.0082 7.86911 11.983 7.80837C11.9578 7.74762 11.9208 7.69245 11.8743 7.646L8.87426 4.646C8.78038 4.55211 8.65304 4.49937 8.52026 4.49937C8.38749 4.49937 8.26015 4.55211 8.16626 4.646C8.07238 4.73989 8.01963 4.86722 8.01963 5C8.01963 5.13277 8.07238 5.26011 8.16626 5.354L10.3133 7.5L4.52026 7.5Z"
        fill="url(#paint0_linear_476_30643)"
        fillOpacity="0.82"
      />
      <defs>
        <linearGradient
          id="paint0_linear_476_30643"
          x1="0.0202637"
          y1="16"
          x2="14.5203"
          y2="-1.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A13E96" />
          <stop offset="0.515" stopColor="#0893D5" />
          <stop offset="1" stopColor="#12B29B" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 -2.34446e-06C12.6522 -2.46039e-06 15.1957 1.05357 17.0711 2.92893C18.9464 4.80429 20 7.34783 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34783 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 -3.21184e-07 12.6522 -4.37114e-07 10C-5.53044e-07 7.34783 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34783 -2.22853e-06 10 -2.34446e-06ZM5.625 9.375C5.45924 9.375 5.30027 9.44085 5.18306 9.55806C5.06585 9.67527 5 9.83424 5 10C5 10.1658 5.06585 10.3247 5.18306 10.4419C5.30027 10.5592 5.45924 10.625 5.625 10.625L12.8662 10.625L10.1825 13.3075C10.0651 13.4249 9.99921 13.584 9.99921 13.75C9.99921 13.916 10.0651 14.0751 10.1825 14.1925C10.2999 14.3099 10.459 14.3758 10.625 14.3758C10.791 14.3758 10.9501 14.3099 11.0675 14.1925L14.8175 10.4425C14.8757 10.3844 14.9219 10.3155 14.9534 10.2395C14.9849 10.1636 15.0011 10.0822 15.0011 10C15.0011 9.91779 14.9849 9.83639 14.9534 9.76046C14.9219 9.68453 14.8757 9.61556 14.8175 9.5575L11.0675 5.8075C10.9501 5.69014 10.791 5.62421 10.625 5.62421C10.459 5.62421 10.2999 5.69014 10.1825 5.8075C10.0651 5.92486 9.99921 6.08403 9.99921 6.25C9.99921 6.41597 10.0651 6.57514 10.1825 6.6925L12.8662 9.375L5.625 9.375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowCircleIcon;
